export class ReferralRequestError extends Error {
  constructor(
    public readonly status: number,
    public readonly code: string
  ) {
    super('Ekki tókst að framkvæma aðgerðina. Athugaðu stöðu tilvísunar.');
  }
}

export const referralRequest = async <T>(path: string, method = 'GET', body?: unknown): Promise<T> => {
  let response: Response;
  try {
    response = await fetch(path, {
      method,
      credentials: 'include',
      cache: 'no-store',
      headers: method === 'GET' ? {} : { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: body === undefined ? undefined : JSON.stringify(body),
    });
  } catch {
    throw new ReferralRequestError(503, 'unavailable');
  }
  let data: unknown;
  try {
    data = await response.json();
  } catch {
    throw new ReferralRequestError(503, 'unavailable');
  }
  if (!response.ok) {
    const code =
      data && typeof data === 'object' && 'code' in data && typeof data.code === 'string' ? data.code : 'unavailable';
    throw new ReferralRequestError(response.status, code);
  }
  return data as T;
};
